import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { action, autorunAsync, observable, autorun, toJS } from 'mobx';
import moment from 'moment';
import Form, { FormBody, DateInput, SelectInput, FormActions } from '../../Form';
import * as api from '../../../actions/api';
import GraphView from '../../GraphView';
import { getDisplayDate, toUtc } from '../../../libs/date';
import Spinner from '../../Spinner';
import _ from 'lodash';
import {insertMissingTimeStampData, preference } from "../../../libs/localStorage";
import StationObservationTime from "./StationObservationTime";
import Highcharts from 'highcharts';

@inject('stationStore', 'dataSeriesStore', 'rolePermissionStore', 'parameterStore')
@observer
class StationObservationList extends Component {

  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };

  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
  };

  // @observable filters = {
  // series_id: '',
  // date_from: '',
  // date_to: '',
  // };
  @observable filters = {
    series_id: null,
    date_from: moment().add(-6, 'days').format('YYYY-MM-DD'),
    date_to: moment().format('YYYY-MM-DD'),
  };
  @observable station = {};
  @observable observations = [];
  @observable dataSeriesItems = [];
  @observable graphSelect = {
    selected: false,
    filters: null
  };
  @observable loading = false;
  @observable tableView = false;
  @observable toInsertMissingData = insertMissingTimeStampData.get();

  constructor(props) {
    super(props);

    this.state = {
      height: window.innerHeight,
      // product: '',
      series: 1, // props.seriesList[0].id,   // TODO Check if list is empty
      from: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      data: {
        data: [],
        categories: [],
        seriesData: [],
      },
      titleText: '',
      unit: ''
    };
    this.exportCSV = this.exportCSV.bind(this);
  }

  dispose;

  componentWillMount() {
    const { params: { id }, stationStore, dataSeriesStore, parameterStore } = this.props;
    if (!parameterStore.items.length && !parameterStore.isLoading) parameterStore.fetchItems();
    this.dispose = autorun(() => {
      // dataSeriesStore.fetchItems();
      // stationStore.fetchField(id, 'observation');
      // const station = stationStore.findById(id);
      // this.reset(station);

      if (this.dataSeriesItems.length === 0 && parameterStore.items.length > 0) {
        stationStore.fetchDataSeries(id)
          .then(dataSeriesItems => {
            this.resetDataSeriesItems(dataSeriesItems);
            this.urlData()
          });
      }
    });
  }

  urlData() {
    const currentUrl = window.location.href;
    const queryParams = new URLSearchParams(currentUrl.split('?')[1]);
    const date_from = queryParams.get('date_from');
    const series_id = queryParams.get('series_id');
    const date_to = queryParams.get('date_to');
    if (series_id && date_from && date_to) {
      this.filters.series_id = series_id;
      this.filters.date_from = date_from;
      this.filters.date_to = date_to;
    }
    this.showObservations({ preventDefault: () => { } });
  }

  componentWillUnmount() {
    this.dispose();
  }

  @action reset(item) {
    if (!item) {
      return;
    }
    // this.station = item.asJson;
    this.observations = item;
  }

  @action resetDataSeriesItems(item) {
    if (!item) {
      return;
    }
    // this.station = item.asJson;
    const { parameterStore } = this.props;
    this.dataSeriesItems = item.map(item => (Object.assign(item, { parameter: parameterStore.findById(item.parameter_id) })));
  }

  @action onChangeToInsertMissingData = e => {
    this.toInsertMissingData = !this.toInsertMissingData
    insertMissingTimeStampData.set((this.toInsertMissingData));
  };

  @action onChangeParameter = (e) => {
    this.setState({ seriesData: null });
    this.filters.parameterId = e.target.value;
  }
  @action onChangeSeries = (e) => {
    this.setState({ seriesData: null });
    this.filters.series_id = e.target.value;

    let dataSeries = this.dataSeriesItems.find(item => +item.id === +e.target.value)
    let parameter = this.props.parameterStore.findById(dataSeries.parameter_id);
    if (!!parameter) {
      this.tableView = parameter.property === 'time' || +parameter.table === 2
    }
  }
  @action onChangeDateFrom = (e) => {
    this.setState({ seriesData: null });
    this.filters.date_from = e.target.value;
  }
  @action onChangeDateTo = (e) => {
    this.setState({ seriesData: null });
    this.filters.date_to = e.target.value;
  }
  @action showObservations = (e) => {
    e.preventDefault();

    if (!this.filters.series_id) {
      return;
    }
    if (!this.filters.date_from) {
      return;
    }
    if (!this.filters.date_to) {
      return;
    }
    this.loading = true;

    this.setState({ seriesData: null });
    api.observation.fetchAll(this.filters)
      .then((observations) => {
        observations.data = (() => {
          if (!observations.data || observations.data.length == 0) return observations.data;
          let groupedObservation = _.groupBy(observations.data, item => item.datetime);
          let uniqueObservations = [];
          Object.keys(groupedObservation).map(item => {
            if (groupedObservation[item][0].value !== 'NaN') uniqueObservations.push(groupedObservation[item][0])
          });
          return uniqueObservations;
        })();

        this.reset(observations);

        const { date_from: dateFrom, date_to: dateTo, series_id } = this.filters;

        const titleText = `${observations.parameter_name} from ${dateFrom} to ${dateTo}`;
        const parameter = this.dataSeriesItems.find(item => +item.id === +this.filters.series_id);
        parameter && parameter.parameter_unit && parameter.parameter_unit.symbol ? this.setState({ unit: parameter.parameter_unit.symbol }) : this.setState({ unit: '' });

        const dataState = this.state.data || {
          data: [],
          categories: [],
          seriesData: [],
        };
        dataState.data = (
          observations.data && observations.data.map(observation => parseFloat(observation.value))
        ) || [];
        dataState.categories = (
          observations.data && observations.data.map(observation => observation.datetime)
        ) || [];
        let seriesData = [];
        seriesData = observations.data ? this.insertMissingData(
          observations.data.map(({ datetime, value }) => [getDisplayDate(datetime, { returnMills: true }), value])
        ) : [];

        seriesData = [[moment.utc(this.filters.date_from).hours(0).minutes(0).seconds(0).valueOf(), null], ...seriesData, [moment.utc(this.filters.date_to).hours(23).minutes(59).seconds(59).valueOf(), null]];

        this.context.router.push({
          pathname: `/station/${this.props.params.id}/observation`,
          query: { series_id, date_from: dateFrom, date_to: dateTo }
        })
        // seriesData.push();

        this.loading = false;

        this.setState({
          data: observations.data,
          titleText,
          seriesData
        });
      })
      .catch(err => {
        this.loading = false;
        console.log('err', err);
      });
  }
  @action exportCSV = (e) => {
    e.preventDefault();

    const { titleText, seriesData } = this.state;

    let textToSave = 'dateTime,value\n';
    seriesData.map((d, index) => {
      // let datetime = moment.utc(d[0]).format('MM/DD/YYYY HH:mm:ss.SSS'),
      let datetime = moment.utc(d[0]).format('YYYY-MM-DD HH:mm:ss'),
        value = !!d[1] || d[1] === 0 ? d[1] : '';
      textToSave = textToSave.concat(datetime + ', ' + value + '\n');
    });

    let hiddenElement = document.createElement('a');
    document.body.appendChild(hiddenElement);
    let csvData = new Blob([textToSave], { type: 'text/csv' });
    hiddenElement.href = URL.createObjectURL(csvData);
    // hiddenElement.href = 'data:attachment/text,' + encodeURI(textToSave);
    hiddenElement.target = '_blank';
    hiddenElement.download = titleText + '.csv';
    hiddenElement.click();
  };

  onGraphSelect = event => {
    // setTimeout(() => {
    let xAxis = event.xAxis;
    if (xAxis) {
      let datetimeArr = xAxis[0].axis.series[0].processedXData;
      // console.log(moment(datetimeArr[0]).format('YYYY-MM-DDTkk:mm:ss'), moment(datetimeArr[datetimeArr.length - 1]).format('YYYY-MM-DDTkk:mm:ss'))
      // let mino = datetimeArr[0], maxo = datetimeArr[datetimeArr.length - 1];
      let min = Math.floor(xAxis[0].min), max = Math.floor(xAxis[0].max);
      this.graphSelect = {
        selected: true,
        filters: {
          series_id: this.filters.series_id,
          date_from: moment(min + new Date().getTimezoneOffset() * 60000).format('YYYY-MM-DDTHH:mm:ss'),
          date_to: moment(max + new Date().getTimezoneOffset() * 60000).format('YYYY-MM-DDTHH:mm:ss')
        }
      };
    }
    // }, 500);
  };

  onClickEdit = (e) => {
    e.preventDefault();
    let { series_id, date_from, date_to } = this.filters;
    this.context.router.push({
      pathname: `/station/${this.props.params.id}/edit-observation`,
      query: this.graphSelect.filters || { series_id, date_from, date_to }
    })
  };

  onClickGraph = e => {
    if (e.srcElement.firstChild.data == 'Reset Zoom') {
      this.graphSelect.selected = false;
    }
  }

  insertMissingData = observation => {
    const dataSeries = this.dataSeriesItems.find(item => +item.id === +this.filters.series_id);
    let dataSeriesInterval = dataSeries && (dataSeries.interval || dataSeries.interval_1) * 60 * 1000;
    if (!this.toInsertMissingData || !dataSeriesInterval) return observation;
    else {
      let data = [];
      let timeCounter = observation[0][0], endTime = observation[observation.length - 1][0];
      while (timeCounter <= endTime) {
        // eslint-disable-next-line
        let item = observation.find(item => Math.floor(item[0] / dataSeriesInterval) * dataSeriesInterval === Math.floor(timeCounter / dataSeriesInterval) * dataSeriesInterval);
        if (item) data.push(item);
        else data.push([timeCounter, null]);
        timeCounter += dataSeriesInterval;
      }
      return data;
    }
  }

  render() {
    const { rolePermissionStore, parameterStore } = this.props;
    let timezone = preference.get().timezone || moment.tz.guess();

    let selectedDataSeries = this.dataSeriesItems.find(item => +item.id === +this.filters.series_id);

    const options = {
      chart: {
        type: selectedDataSeries && selectedDataSeries.property === 'Accumulative' ? 'column' : 'line',
        events: {
          selection: this.onGraphSelect,
          // click: this.onClickGraph
        },
        zoomType: 'x',
      },
      // series: [{
      // name: 'Value',
      // data: this.state.data.data,
      // }],
      title: {
        text: this.state.titleText,
      },
      xAxis: {
        type: 'datetime',
        // categories: (seriesData && seriesData.map(item => {
        // return toUtc(new Date(item[0]));
        // })) || [],
        // minTickInterval: parseInt(this.state.data.data.length / 10),
         dateTimeLabelFormats: { // don't display the dummy year
          second: '%H:%M:%S',
          // day: '%b',
          // month: '%e. %b',
          // year: '%b',
        },
      },
      yAxis: {
        title: {
          text: `${selectedDataSeries && selectedDataSeries.name}  (${selectedDataSeries && selectedDataSeries.parameter_unit && selectedDataSeries.parameter_unit.symbol})` //this.state.unit,
        },
      },
      tooltip:{
        formatter:function() {
          return `
          ${Highcharts.dateFormat('%A, %b %e, %Y %H:%M', this.x)}<br/>
          ${this.series.name}: <b>${this.y}</b>
          `
        }
      },
      series: [{
        name: this.state.titleText,
        data: this.state.seriesData,
        cropThreshold: 9999999
      }],
    };

    return (
      <div>
        {/*
         <SelectInput
         label={'Parameter'}
         fields={{ label: 'name', value: 'id' }}
         options={parameterStore.items.toJS()}
         onChange={this.onChangeParameter}
         />
         */}
        <Form>
          <FormBody>
            <SelectInput
              label={'Data Series'}
              value={this.filters.series_id}
              fields={{ label: 'name', value: 'id' }}
              options={this.dataSeriesItems}
              onChange={this.onChangeSeries}
              filterOptions={(options, filterText) => parameterStore.filterParameters(options, filterText, 'parameter.code')}
            />
            <DateInput
              label={'Date From'}
              value={this.filters.date_from}
              onChange={this.onChangeDateFrom}
            />
            <DateInput
              label={'Date To'}
              value={this.filters.date_to}
              onChange={this.onChangeDateTo}
            />
            <div className='formInput'>
              <label>Insert timestamp for missing data</label>
              <input type="checkbox" checked={this.toInsertMissingData} onChange={this.onChangeToInsertMissingData} />
            </div>
          </FormBody>
          <FormActions>
            <button onClick={this.showObservations}>View</button>
            {<button onClick={this.exportCSV}>Download CSV <span style={{ fontSize: '12px' }}>({timezone}{timezone !== 'UTC' && ' ' + moment.tz(timezone).zoneAbbr()})</span></button>}
            {!this.loading && !!options.series[0].data && rolePermissionStore.validateRole('view edit-observation') &&
              <button onClick={this.onClickEdit} className="pull-right">Edit</button>}
          </FormActions>
        </Form>

        {this.loading && <Spinner />}
        {/*{!this.loading && !!options.series[0].data && <GraphView options={options}/>}*/}
        {!this.loading && !!this.state.seriesData && !!this.state.seriesData.length ? this.tableView ? <StationObservationTime property={selectedDataSeries.property} data={this.state.seriesData} /> : <GraphView options={options} /> : ''}
      </div>
    );
  }
}


export default StationObservationList;



// WEBPACK FOOTER //
// ./src/components/Station/Observation/StationObservationList.js